import { useFeatureEntitlements } from '@frontegg/react';
import { AmbientAiIcon, TemplateStudioMenuIcon, MemoryIcon } from 'src/icons';
import { ProIcon } from 'src/icons/Pro.icon';
import { LockIcon } from 'src/icons/Lock.icon';
import { AutotemplateMenuIcon } from 'src/icons';
import { UpgradeTooltip } from './components/Payments/UpgradeTooltip';
import { useIsOP } from 'src/hooks/misc';

const getAutoTemplateMenuItem = (hasAutoTemplateAccess) => {
  if (hasAutoTemplateAccess) {
    return {
      path: '/autotemplate',
      title: <span className="flex items-center">Auto Template</span>,
      icon: <AutotemplateMenuIcon />,
    };
  }
  return {
    path: '/autotemplate',
    title: (
      <UpgradeTooltip>
        <span className="flex items-center gap-2">
          Auto Template
          <LockIcon />
        </span>
      </UpgradeTooltip>
    ),
    icon: <AutotemplateMenuIcon />,
  };
};

const AmbientSoloSideMenus = ({ ambientAIMenu, isActive }) => {
  const { isEntitled: hasIntakeAccess } = useFeatureEntitlements('intake');
  const { isEntitled: hasFollowupAccess } = useFeatureEntitlements('followup');
  const { isEntitled: hasMemoryAccess } = useFeatureEntitlements('memory');
  const { isEntitled: hasAutoTemplateAccess } =
    useFeatureEntitlements('auto-template');
  const hasVCAAccess = hasIntakeAccess || hasFollowupAccess;
  const isOP = useIsOP();

  const menus = [];

  const encountersMenuItem = {
    path: '/encounters',
    title: `${isOP ? 'Opie' : 'Aura'} AI Scribe`,
    icon: <AmbientAiIcon isFilled={ambientAIMenu && isActive} />,
  };

  if (ambientAIMenu) {
    const submenuItems = [];
    if (hasVCAAccess && hasMemoryAccess) {
      submenuItems.push({
        path: '/memory',
        title: 'Memory',
        icon: <MemoryIcon />,
      });
    }

    if (submenuItems.length > 0 || hasVCAAccess) {
      encountersMenuItem.submenu = submenuItems;
    }
  }
  menus.push(encountersMenuItem);

  if (!isOP) {
    menus.push(getAutoTemplateMenuItem(hasAutoTemplateAccess));
  }

  if (ambientAIMenu) {
    menus.push({
      path: '/setting',
      title: 'Template Studio',
      icon: <TemplateStudioMenuIcon />,
    });
  }

  return menus;
};

export const MemorySideMenus = () => {
  const { isEntitled: memoryFeature } = useFeatureEntitlements('memory');

  const menus = memoryFeature
    ? [
        {
          path: '/memory',
          title: (
            <span className="flex items-center gap-2">
              Memory
              <ProIcon />
            </span>
          ),
          icon: <MemoryIcon />,
        },
      ]
    : [
        {
          path: '/memory',
          title: (
            <UpgradeTooltip>
              <span className="flex items-center gap-2">
                Memory
                <LockIcon />
              </span>
            </UpgradeTooltip>
          ),
          icon: <MemoryIcon />,
        },
      ];
  return menus;
};
export default AmbientSoloSideMenus;
